import React from "react";

import { Button } from "semantic-ui-react";
import { IConveyorBoxUI } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";

import { useSelector } from "react-redux";
import useVerifyItemsA2 from "../../../hooks/useVerifyItems/useVerifyItemsA2";

const AutoVerifyAllItemsButton = () => {
  const conveyorBoxReview: IConveyorBoxUI = useSelector(
    (state: any) => state.conveyorBoxReviewReducer
  );
  const items = conveyorBoxReview.items.active;
  const { isAllItemsVerified, onAutoVerifyQuantityAll } = useVerifyItemsA2({
    items: items,
  });

  if (isAllItemsVerified) return null;
  return (
    <Button
      onClick={() => onAutoVerifyQuantityAll()}
      content="Verifiera allt plock"
      size="big"
      inverted
      color="red"
      aria-label="Verifiera allt plock"
      icon="exclamation"
    />
  );
};

export default AutoVerifyAllItemsButton;
